import { Outlet } from 'react-router-dom'
import { UnifiedNavigation } from '@/components/navigation/UnifiedNavigation'

export default function DashboardLayout() {
  return (
    <div className="min-h-screen bg-background">
      <UnifiedNavigation preset="dashboard" />
      <main className="container mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  )
}
